/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert a Phred quality score into its base-calling error probability and accuracy, and see the Phred+33 and Phred+64 ASCII characters used in FASTQ files. You can also convert an error probability back to a Q score.`)
};

const es_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte una puntuación de calidad Phred en su probabilidad de error de llamada de base y precisión, y visualiza los caracteres ASCII Phred+33 y Phred+64 usados en archivos FASTQ. También puedes convertir una probabilidad de error de vuelta a una puntuación Q.`)
};

const de_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandeln Sie einen Phred-Qualitätswert in seine Basenaufruf-Fehlerwahrscheinlichkeit und -Genauigkeit um und sehen Sie die in FASTQ-Dateien verwendeten Phred+33- und Phred+64-ASCII-Zeichen. Sie können auch eine Fehlerwahrscheinlichkeit zurück in einen Q-Wert umwandeln.`)
};

const nl_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet een Phred-kwaliteitsscore om naar de foutkans bij basecalling en de nauwkeurigheid, en bekijk de Phred+33- en Phred+64-ASCII-tekens die in FASTQ-bestanden worden gebruikt. Je kunt ook een foutkans omzetten naar een Q-score.`)
};

const fr_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez un score de qualité Phred en probabilité d'erreur et précision d'appel de base, et visualisez les caractères ASCII Phred+33 et Phred+64 utilisés dans les fichiers FASTQ. Vous pouvez aussi convertir une probabilité d'erreur en score Q.`)
};

const it_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti un punteggio di qualità Phred nella sua probabilità di errore di base-calling e accuratezza, e visualizza i caratteri ASCII Phred+33 e Phred+64 usati nei file FASTQ. Puoi anche convertire una probabilità di errore in un punteggio Q.`)
};

const pt_br2_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta um escore de qualidade Phred em sua probabilidade de erro de chamada de base e precisão, e veja os caracteres ASCII Phred+33 e Phred+64 usados em arquivos FASTQ. Você também pode converter uma probabilidade de erro de volta em um escore Q.`)
};

const pt_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta uma pontuação de qualidade Phred na sua probabilidade de erro de chamada de base e precisão, e veja os caracteres ASCII Phred+33 e Phred+64 usados em ficheiros FASTQ. Também pode converter uma probabilidade de erro de volta para uma pontuação Q.`)
};

const ja_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred品質スコアを塩基コールのエラー確率と精度に変換し、FASTQファイルで使われるPhred+33およびPhred+64のASCII文字を確認できます。エラー確率をQスコアに逆変換することもできます。`)
};

const zh_phred_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 Phred 质量分数转换为碱基判读的错误概率和准确率，并查看 FASTQ 文件中使用的 Phred+33 和 Phred+64 ASCII 字符。你也可以将错误概率转换回 Q 分数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_intro", locale)
	if (locale === "en") return en_phred_intro(inputs)
	if (locale === "es") return es_phred_intro(inputs)
	if (locale === "de") return de_phred_intro(inputs)
	if (locale === "nl") return nl_phred_intro(inputs)
	if (locale === "fr") return fr_phred_intro(inputs)
	if (locale === "it") return it_phred_intro(inputs)
	if (locale === "pt-BR") return pt_br2_phred_intro(inputs)
	if (locale === "pt") return pt_phred_intro(inputs)
	if (locale === "ja") return ja_phred_intro(inputs)
	return zh_phred_intro(inputs)
};